import { ProjectUpdateData } from '@src/views/project/types';
import {
  GetProjectsParams,
  PreviewPaymentWithoutPaymentIdParams,
} from './projects';
import { oliveApi } from '../index';

const url = '/admin/v1/projects';

export const getProjectsListApi = async (params?: GetProjectsParams) => {
  return await oliveApi.GET<GetProjectsParams, any>(url, params);
};

export const getProjectByIdApi = async (id: number) => {
  return await oliveApi.GET<any, any>(`${url}/${id}`);
};

export const updateProjectDataByIdApi = async (
  id: number,
  data: ProjectUpdateData
) => {
  return await oliveApi.PATCH<ProjectUpdateData, any>(`${url}/${id}`, data);
};

export const cancelProjectByIdApi = async ({
  projectId,
}: {
  projectId: string;
}) => {
  return await oliveApi.POST(`${url}/${projectId}/cancel`);
};

export const previewPaymentWithoutPaymentIdApi = async ({
  companyId,
  projectId,
  disablePromotion,
  companyCouponId,
}: PreviewPaymentWithoutPaymentIdParams) => {
  return await oliveApi.POST<any, any>(
    `/v1/companies/${companyId}/payments/preview`,
    {
      projectId,
      disablePromotion,
      companyCouponId,
    }
  );
};
